export default "__VITE_ASSET__BYdWTqUF__"